module.exports = __webpack_public_path__ + "img/17-27-183.2ba235e7.jpg";